import JSCookie from 'js-cookie'

const tokenCookie = process.env.REACT_APP_AUTH_TOKEN
const socketCookie = process.env.REACT_APP_SOCKET_TOKEN
const userCookie = process.env.REACT_APP_USER_TOKEN

export const TokenSession = {
    set: token => {
        JSCookie.set(tokenCookie, token)
    },
    unset: () => {
        JSCookie.remove(tokenCookie)
    },
    get: () => {
        const token = JSCookie.get(tokenCookie)
        if (!token) return
        return JSON.parse(token)
    },
    formatToken: token => ({
        type: token.type,
        token: token.token
    })
}

export const SocketSession = {
    set: socketId => {
        JSCookie.set(socketCookie, socketId)
    },
    unset: () => {
        JSCookie.remove(socketCookie)
    },
    get: () => {
        const socketId = JSCookie.get(socketCookie)
        if (!socketId) return
        return socketId
    }
}

export const UserSession = {
    set: userUUID => {
        JSCookie.set(userCookie, userUUID)
    },
    unset: () => {
        JSCookie.remove(userCookie)
    },
    get: () => {
        const userUUID = JSCookie.get(userCookie)
        if (!userUUID) return
        return userUUID
    }
}



// WEBPACK FOOTER //
// src/utils/session.js